import { zh } from "./zh";
import { de } from "./de";
import { en } from "./en";
import { fi } from "./fi";
import { fr } from "./fr";
import { frca } from "./frca";
import { nl } from "./nl";
import { no } from "./no";
import { se } from "./se";
import { it } from "./it";
import { ptbr } from "./ptbr";
import { spmx } from "./spmx";

const langs = {
  en,
  de,
  se,
  fr,
  frca,
  fi,
  no,
  it,
  nl,
  ptbr,
  spmx,
  zh,
};
export default langs;
